import React, { useRef, useEffect } from 'react';
import ModalControlled from '../../../components/ModalControlled';
import DriverRequests from '../../../components/modals/DriverRequests';
import PickupStops from '../../../components/modals/PickupStops';
import SelectMultipleRouteStops from '../../../components/modals/SelectMultipleRouteStops';
import modalTypes from '../../../enums/modalTypes';
import modals from '../../../enums/modals';
import StopMoveTo from '../../../components/modals/StopMoveTo';
import TransferTo from '../../../components/modals/TransferTo';
import TransferSummary from '../../../components/modals/TransferSummary';
import RemoveParcels from '../../../components/modals/RemoveParcels';
import MergeStopsModal from '../../../components/modals/MergeStops';
import CloseToteModal from '../../../components/modals/ConfirmCloseTote';
import { useModalContext } from '../../../components/ModalControlled/ModalProvider';
import { ParcelsInfoModal } from '../../../components/common/Table/StopInfoItem';
import ReconsolidationNotice from '../../../components/modals/ReconsolidationNotice';

const ModalsContainer = () => {
  const { registerModalRef } = useModalContext();

  const selectMultipleRouteStopsModalRef = useRef();
  const requestModalRef = useRef();
  const pickupStopsModalRef = useRef();
  const moveToModalRef = useRef();
  const transferToModalRef = useRef();
  const summaryModalRef = useRef();
  const removeParcelsModalRef = useRef();
  const mergeStopsModalRef = useRef();
  const closeToteModalRef = useRef();
  const parcelsInfoModalRef = useRef();
  const reconsolidationNoticeModalRef = useRef();
  useEffect(() => {
    registerModalRef(modals.SELECT_MULTIPLE, selectMultipleRouteStopsModalRef);
    registerModalRef(modals.REQUEST, requestModalRef);
    registerModalRef(modals.PICK_REQUEST, pickupStopsModalRef);
    registerModalRef(modals.MERGE_STOPS, mergeStopsModalRef);
    registerModalRef(modals.MOVE_TO, moveToModalRef);
    registerModalRef(modals.TRANSFER_TO, transferToModalRef);
    registerModalRef(modals.TRANSFER_SUMMARY, summaryModalRef);
    registerModalRef(modals.REMOVE, removeParcelsModalRef);
    registerModalRef(modals.CLOSE_TOTE, closeToteModalRef);
    registerModalRef(modals.PARCELS_INFO, parcelsInfoModalRef);
    registerModalRef(
      modals.RECONSOLIDATION_NOTICE,
      reconsolidationNoticeModalRef
    );
  }, [registerModalRef]);

  return (
    <>
      <ModalControlled
        renderWhenOpen
        ref={selectMultipleRouteStopsModalRef}
        Component={SelectMultipleRouteStops}
        type={modalTypes.RIGHT_DRAWER}
        modalKey={modals.SELECT_MULTIPLE}
      />
      <ModalControlled
        ref={requestModalRef}
        Component={DriverRequests}
        renderWhenOpen
        type={modalTypes.RIGHT_DRAWER}
        modalKey={modals.REQUEST}
      />
      <ModalControlled
        renderWhenOpen
        ref={pickupStopsModalRef}
        Component={PickupStops}
        type={modalTypes.RIGHT_DRAWER}
        modalKey={modals.PICK_REQUEST}
      />
      <ModalControlled
        ref={mergeStopsModalRef}
        Component={MergeStopsModal}
        renderWhenOpen
        type={modalTypes.RIGHT_DRAWER}
        modalKey={modals.MERGE_STOPS}
      />
      <ModalControlled
        Component={StopMoveTo}
        ref={moveToModalRef}
        renderWhenOpen
        type={modalTypes.RIGHT_DRAWER}
        modalKey={modals.MOVE_TO}
      />
      <ModalControlled
        ref={transferToModalRef}
        Component={TransferTo}
        renderWhenOpen
        type={modalTypes.RIGHT_DRAWER}
        modalKey={modals.TRANSFER_TO}
      />
      <ModalControlled
        ref={summaryModalRef}
        Component={TransferSummary}
        renderWhenOpen
        type={modalTypes.RIGHT_DRAWER}
        modalKey={modals.TRANSFER_SUMMARY}
      />
      <ModalControlled
        ref={removeParcelsModalRef}
        Component={RemoveParcels}
        renderWhenOpen
        type={modalTypes.RIGHT_DRAWER}
        modalKey={modals.REMOVE}
      />
      <ModalControlled
        ref={closeToteModalRef}
        Component={CloseToteModal}
        renderWhenOpen
        type={modalTypes.DEFAULT}
        modalKey={modals.CLOSE_TOTE}
      />
      <ModalControlled
        ref={parcelsInfoModalRef}
        renderWhenOpen
        Component={ParcelsInfoModal}
      />
      <ModalControlled
        ref={reconsolidationNoticeModalRef}
        renderWhenOpen
        Component={ReconsolidationNotice}
      />
    </>
  );
};

export default ModalsContainer;
